import { createContext } from 'react';

export const GeolocationContext = createContext(false);
